import { useQuery } from "@tanstack/react-query";
import { API_URL } from "../lib/api";

export const usePublicContent = () => useQuery({
  queryKey: ["public-content"],
  queryFn: async () => {
    const response = await fetch(`${API_URL}/content/public`, { cache: "no-store" });
    if (!response.ok) throw new Error("Unable to load website content");
    return response.json();
  },
  staleTime: 0,
  refetchOnMount: "always",
});